<template>
  <div id="accounts-payable">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="header d-flex justify-space-between pr-5 align-center">
        <h1 class="ml-5 pl-0">Entregadores a pagar</h1>

        <v-btn
          :disabled="selectedCheckbox.length == 0"
          :loading="isCreatePaymentOrderLoading"
          elevation="2"
          color="success"
          large
          @click="openDialog()"
          >CRIAR ORDEM DE PAGAMENTO
        </v-btn>
      </div>

      <v-expansion-panels class="px-5 py-1 mt-2" accordion>
        <v-expansion-panel class="elevation-1">
          <v-expansion-panel-header color="#f2f2f2" class="px-4">
            <span>Filtrar por</span>
            <template v-slot:actions>
              <v-icon color="black"> mdi-chevron-down </v-icon>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="mt-2 pb-1">
              <v-col cols="12" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedDate"
                      label="Data de Início"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    :active-picker.sync="activePicker"
                    @change="save1"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedEndDate"
                      label="Data de Fim"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date1"
                    :active-picker.sync="activePicker1"
                    @change="save2"
                    locale="pt-br"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="directDelivererId"
                  :items="getSummaryData"
                  label="Entregador"
                  item-text="name"
                  item-value="id"
                  @change="saveDeliverer()"
                  class="auto-complete"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="CTENumber" label="Número CTE" @change="saveCteNumber()"></v-text-field>
              </v-col>

              <v-col cols="12" md="12" class="d-flex justify-end align-center">
                <v-btn
                  :disabled="!hasFilters"
                  elevation="2"
                  color="red"
                  class="mx-2"
                  :dark="hasFilters"
                  @click="cleanFilter()"
                >
                  Limpar Filtros
                </v-btn>
                <v-btn
                  :loading="isDirectDeliverersLoading"
                  :disabled="!hasFilters"
                  :dark="hasFilters"
                  elevation="2"
                  color="green"
                  @click="search()"
                >
                  Buscar
                </v-btn>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="table mt-10 p-relative">
        <table-title-row :columnsOptions="columnOptions"></table-title-row>
        <v-progress-linear v-if="isDirectDeliverersLoading" indeterminate color="primary"></v-progress-linear>
        <div v-if="nodes.length != 0">
          <template v-for="(node, nodeIndex) in nodes">
            <div :key="node.data.id">
              <table-body-row
                :checkboxDisabled="!node.hasSelectedChildren && selectedCheckbox.length > 0"
                :node="node"
                :nodeIndex="nodeIndex"
                :columns="columns"
                :lengthDataToTruncate="30"
                type="Entregador"
                enableCheckbox
                :selectedCheckbox="selectedCheckbox"
                @onExpand="onExpand(node)"
                @changeCheckbox="changeSelectedCheckbox"
              >
              </table-body-row>
              <v-row v-if="node.open" style="margin-top: 0">
                <v-progress-linear
                  v-if="loadingCourierKey === nodeIndex && isCourierLoading"
                  class="mx-3"
                  indeterminate
                  color="primary"
                ></v-progress-linear>
                <v-col cols="12" class="mb-4">
                  <v-card>
                    <v-card-text class="p-5">
                      <table-title-row :columnsOptions="columnsSchipmentsOptions"></table-title-row>
                      <template v-for="(shipment, shipmentIndex) in node.children">
                        <div :key="shipment.data.id">
                          <table-body-row
                            :node="shipment"
                            :nodeIndex="shipmentIndex"
                            :columns="columnsSchipments"
                            :lengthDataToTruncate="40"
                            type="Contas"
                            enableCheckbox
                            :selectedCheckbox="selectedCheckbox"
                            @changeCheckbox="changeSelectedCheckbox"
                            @onExpand="onExpandBoarding(shipment)"
                            :checkboxDisabled="!node.hasSelectedChildren && selectedCheckbox.length > 0"
                            @receiptFlagClick="handleRedirectToReceiptsManagementByBoarding(shipment.data)"
                          >
                            <template #boardingId="{ item }">
                              <span>
                                <router-link :to="`/shipments/boardingId/${item}`" target="_blank">
                                  {{ item }}
                                </router-link>
                              </span>
                            </template>
                          </table-body-row>

                          <Status :nodeIndex="shipmentIndex" :status="shipment.data.boardingStatus" />

                          <v-row v-if="shipment.open" style="margin-top: 0">
                            <v-progress-linear
                              v-if="loadingBoardingKey === shipmentIndex && isNfesLoading"
                              class="mx-3"
                              indeterminate
                              color="primary"
                            ></v-progress-linear>

                            <v-col cols="12" class="mb-4">
                              <v-card>
                                <v-card-text class="p-5">
                                  <table-title-row :columnsOptions="columnsNfesOptions"> </table-title-row>
                                  <template v-for="(nfe, nfeIndex) in shipment.children">
                                    <div :key="nfe.data.id">
                                      <table-body-row
                                        :node="nfe"
                                        :nodeIndex="nfeIndex"
                                        :columns="columnsNfes"
                                        :lengthDataToTruncate="30"
                                        type="Nota Fiscal"
                                        :enableDropdown="true"
                                        :itemsDropdown="itemsDropdownNfe"
                                        @actionsDropdown="actionsDropdownNfe"
                                        @receiptFlagClick="handleRedirectToReceiptsManagementByNfe(nfe.data)"
                                      >
                                      </table-body-row>

                                      <Status :nodeIndex="nfeIndex" :status="nfe.data.nfeStatus" />
                                    </div>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>
        </div>
        <div class="table mt-10 p-relative" v-else>Nenhum entregador com entrega finalizada foi encontrado</div>
        <div class="mt50"></div>
        <div class="d-flex justify-space-between">
          <v-pagination v-model="page" :length="1" :total-visible="7"></v-pagination>
        </div>
      </div>
    </v-card>

    <PaymentOrder
      :open="paymentOrder"
      @closePaymentOrder="closeDialog"
      :selectedFather="selectedCourier"
      :selectedItems="selectedShipments"
    />

    <HistoricNfe :id="nfeSelectedId" :open="isOpenHistoryNfe" @closeHistoricNfe="isOpenHistoryNfe = false" />

    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import PaymentOrder from '../../../components/AccountsPayable/PaymentOrder.vue';
import MessagesError from '../../../components/MessagesError.vue';

import TableTitleRow from '../../../components/Table/Table-Title-Row.vue';
import TableBodyRow from '../../../components/Table/Table-Body-Row.vue';
import Status from '@/components/Table/Status.vue';
import HistoricNfe from '@/components/Nfe/HistoricNfe.vue';

import changeCheckbox from '../../../utils/changeSelectedCheckbox';
import maskData from '../../../utils/maskData';
import maskPrice from '../../../utils/maskPrice';
export default {
  name: 'AccountsPayable',
  components: {
    BreadCrumb,
    PaymentOrder,
    TableTitleRow,
    TableBodyRow,
    MessagesError,
    HistoricNfe,
    Status
  },
  data: () => ({
    isCreatePaymentOrderLoading: false,
    selectedCheckbox: [],
    selectedShipments: [],
    isDirectDeliverersLoading: false,
    isCourierLoading: false,
    isNfesLoading: false,
    isOpenHistoryNfe: false,
    loadingCourierKey: null,
    loadingBoardingKey: null,
    selectedCourier: {
      children: [],
      data: { name: '' }
    },
    nodes: [],
    aditional: {
      type: '',
      id: '',
      price: null,
      justification: '',
      date: '',
      observation: ''
    },
    columns: ['name', 'actions'],
    columnsSchipments: [
      'id',
      'numbers',
      'createdAt',
      'advanceAmount',
      'advanceStatus',
      'freightPrice',
      'canhotoType',
      'actions'
    ],
    columnsSchipmentsOptions: [
      {
        value: 'id',
        text: 'ID DO EMBARQUE'
      },
      {
        value: 'numbers',
        text: 'EMBARQUES EXTERNOS'
      },
      {
        value: 'createdAt',
        text: 'DATA DE CRIAÇÃO'
      },
      {
        value: 'advanceAmount',
        text: 'ADIANTAMENTO'
      },
      {
        value: 'advanceStatus',
        text: 'STATUS DO ADIANTAMENTO'
      },
      {
        value: 'freightPrice',
        text: 'VALOR TOTAL'
      },
      {
        value: 'canhotoType',
        text: 'SITUAÇÃO DO CANHOTO'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    columnsNfes: ['type', 'number', 'price', 'completionDate', 'canhotoType', 'actions'],
    columnsNfesOptions: [
      {
        value: 'type',
        text: 'TIPO'
      },
      {
        value: 'number',
        text: 'NÚMERO NFE'
      },
      {
        value: 'price',
        text: 'PREÇO DA NF'
      },
      {
        value: 'completionDate',
        text: 'DATA DE CONCLUSÃO'
      },
      {
        value: 'canhotoType',
        text: 'SITUAÇÃO DO CANHOTO'
      },
      {
        value: 'actions',
        text: 'Ações'
      }
    ],
    loading: false,
    nfeSelectedId: null,
    paymentOrder: false,
    date: null,
    date1: null,
    date2: null,
    CTENumber: null,
    directDelivererId: null,
    menu: false,
    menu1: false,
    menu2: false,
    errors: [],
    error500: null,
    errorsType: 'error',
    activePicker: null,
    activePicker1: null,
    activePicker2: null,
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Financeiro',
        disabled: true,
        to: '/couriers-accounts-payable/'
      },
      {
        text: 'Entregadores a pagar',
        disabled: true
      }
    ],
    columnOptions: [
      {
        value: 'courier',
        text: 'ENTREGADOR'
      },
      { value: 'actions' }
    ],
    itemsDropdownNfe: [{ title: 'Histórico' }]
  }),
  computed: {
    ...mapState('AccountsStore', ['paginate']),
    ...mapGetters('ShipmentStore', ['getManegementShipments']),
    ...mapGetters('AccountsStore', ['getDirectDeliverers']),
    ...mapGetters('CouriersStore', ['getSummaryData']),

    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);
      }
    },
    hasFilters() {
      if (this.date || this.date1 || this.CTENumber || this.directDelivererId) {
        return true;
      }
      return false;
    },
    formattedDate() {
      if (!this.date) return '';
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedEndDate() {
      if (!this.date1) return '';
      const [year, month, day] = this.date1.split('-');
      return `${day}/${month}/${year}`;
    },

    getTheLastThirtyDays() {
      const now = new Date();
      const currentDay = now;
      const thirtyDayAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);

      return {
        thirtyDayAgo: thirtyDayAgo.toISOString().slice(0, 10),
        currentDay: currentDay.toISOString().slice(0, 10)
      };
    }
  },
  created() {
    this.resetFilters();
  },
  mounted() {
    this.filterTheLastThirtyDays();
    this.fetchAllDirectDeliverers();
    this.fetchAllSummaryData();
  },
  methods: {
    ...mapActions('AccountsStore', ['fetchTranshipment', 'fetchDirectDeliverers', 'fetchShipmentsByDirectDelivererId']),
    ...mapActions('ShipmentStore', [
      'fetchManegementShipments',
      'fetchShipmentByID',
      'fetchFastManegementShipmentsNFEByID'
    ]),
    ...mapMutations('AccountsStore', [
      'setFiltersDirectDelivererDirectDelivererId',
      'setFiltersDirectDelivererCteNumber',
      'setFiltersDirectDelivererCreatedAtStart',
      'setFiltersDirectDelivererCreatedAtEnd'
    ]),
    ...mapMutations('ShipmentStore', ['setFiltersManegementDirectDelivererId']),
    ...mapMutations('AccountsStore', [
      'setFiltersDirectDelivererDirectDelivererId',
      'setFiltersDirectDelivererCteNumber',
      'setFiltersDirectDelivererCreatedAtStart',
      'setFiltersDirectDelivererCreatedAtEnd'
    ]),
    ...mapActions('CouriersStore', ['fetchSummaryData']),
    ...mapMutations('NfeStore', ['setSelectedCheckbox', 'getSelectedChecbox']),

    closeDialog(hasChange, message) {
      this.paymentOrder = false;
      if (hasChange) {
        this.fetchAllDirectDeliverers();
      }
      if (message) {
        this.errors = message.errors;
        this.errorsType = message.errorsType;
        this.error500 = message.error500;
      }
    },
    async openDialog() {
      try {
        this.isCreatePaymentOrderLoading = true;
        await this.checkIfChildrenIsSelected();
        this.selectedShipments = [];

        this.selectedCheckbox
          .filter((selected) => selected.type === 'Embarque')
          .forEach((item) => {
            if (item.type != 'Courier' && item.type != 'AccountsPayableFather') {
              if (!this.selectedShipments.includes(item)) {
                this.selectedShipments.push(item);
              }
            }
          });
        this.paymentOrder = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.isCreatePaymentOrderLoading = false;
      }
    },
    cleanFilter() {
      this.date = null;
      this.date1 = null;
      this.CTENumber = null;
      this.directDelivererId = null;

      this.setFiltersDirectDelivererDirectDelivererId(null);
      this.setFiltersManegementDirectDelivererId(null);
      this.setFiltersDirectDelivererCteNumber(null);
      this.setFiltersDirectDelivererCreatedAtStart(null);
      this.setFiltersDirectDelivererCreatedAtEnd(null);

      this.fetchAllDirectDeliverers();
    },
    search() {
      this.fetchAllDirectDeliverers();
    },
    async fetchAllSummaryData() {
      this.loading = true;
      try {
        await this.fetchSummaryData();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async fetchAllDirectDeliverers() {
      this.isDirectDeliverersLoading = true;
      try {
        await this.fetchDirectDeliverers();

        const newShipments = this.getDirectDeliverers.map((item, index) => {
          return {
            key: index,
            data: {
              ...item,
              type: 'Courier'
            },
            children: [],
            type: 'AccountsPayableFather',
            open: false,
            selected: false,
            hasSelectedChildren: false
          };
        });

        console.log(this.date, 'currthis.dateentDay', this.date1);

        this.nodes = newShipments;
      } catch (err) {
        console.error(err);
      } finally {
        this.isDirectDeliverersLoading = false;
        setTimeout(() => {
          this.selectedCheckbox = [];
        }, 0);
      }
    },

    filterTheLastThirtyDays() {
      const { thirtyDayAgo, currentDay } = this.getTheLastThirtyDays;
      this.date = thirtyDayAgo;
      this.date1 = currentDay;

      this.setFiltersDirectDelivererCreatedAtStart(this.date);
      this.setFiltersDirectDelivererCreatedAtEnd(this.date1);
    },

    async fetchShipmentsByDirectDeliverer(selected) {
      try {
        this.isCourierLoading = true;

        const data = await this.fetchShipmentsByDirectDelivererId(selected.data.id);
        const newShipments = data.map((item, index) => {
          return {
            key: selected.key + '-' + index,
            data: {
              ...item,
              createdAt: this.transformDate(item.createdAt),
              freightPrice: this.transformPrice(item.freightPrice),
              price: item.freightPrice,
              canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3',
              type: 'Embarque'
            },
            children: [],
            selected: false,
            open: false,
            type: 'AccountsPayable'
          };
        });

        this.nodes[selected.key].children = newShipments;

        if (selected.selected) {
          this.nodes[selected.key].children.map((item) => {
            item.selected = true;
            if (!this.selectedCheckbox.includes(item.data)) {
              this.selectedCheckbox.push(item.data);
            }
          });
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
        this.isCourierLoading = false;
      }
    },

    async fetchNfesByBoarding(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idBoarding = Number(selected.key.split('-')[1]);

      try {
        this.isNfesLoading = true;

        const data = await this.fetchFastManegementShipmentsNFEByID(selected.data.id);
        const newNfes = data.map((item, index) => {
          return {
            key: idNode + '-' + idBoarding + '-' + index,
            data: {
              ...item,
              completionDate: this.transformDate(item.completionDate),
              type: 'Nota Fiscal',
              canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3'
            },
            type: 'Nfe'
          };
        });

        this.nodes[idNode].children[idBoarding].children = newNfes;
      } catch (err) {
        console.error(err);
      } finally {
        this.isNfesLoading = false;
      }
    },

    async onExpand(selected) {
      this.loadingCourierKey = selected.key;
      this.nodes[selected.key].open = !this.nodes[selected.key].open;
      if (selected.children.length === 0) {
        await this.fetchShipmentsByDirectDeliverer(selected);
      }
    },

    async onExpandBoarding(selected) {
      const idNode = Number(selected.key.split('-')[0]);
      const idBoarding = Number(selected.key.split('-')[1]);

      this.loadingBoardingKey = idBoarding;

      this.nodes[idNode].children[idBoarding].open = !this.nodes[idNode].children[idBoarding].open;

      if (selected.children.length === 0) {
        await this.fetchNfesByBoarding(selected);
      }
    },

    changeSelectedCheckbox(item, children) {
      if (item.type === 'AccountsPayable') {
        const courierKey = item.key.split('-')[0];
        this.selectedCourier = this.nodes[courierKey];

        this.selectedCheckbox = changeCheckbox(this.selectedCheckbox, item, children, 0, 0, 0, this.nodes[courierKey]);
      } else {
        this.selectedCourier = this.nodes[item.key];
        this.selectedCheckbox = changeCheckbox(this.selectedCheckbox, item, children);
      }
    },

    async checkIfChildrenIsSelected() {
      if (this.selectedCheckbox.length > 0) {
        let courierNode = null;
        await this.selectedCheckbox.forEach((item) => {
          if (item.type === 'Courier') {
            this.nodes.map((itemNode) => {
              if (itemNode.data.id === item.id) {
                courierNode = itemNode;
              }
            });
          }
        });
        if (courierNode === null) return;
        if (courierNode.children.length > 0) return;
        try {
          const data = await this.fetchShipmentsByDirectDelivererId(courierNode.data.id);
          const newShipments = data.map((item, index) => {
            return {
              key: courierNode.key + '-' + index,
              data: {
                ...item,
                createdAt: this.transformDate(item.createdAt),
                freightPrice: this.transformPrice(item.freightPrice),
                price: item.freightPrice,
                canhotoType: item.missingReceipt ? '1' : !item.receiptValidated ? '2' : '3'
              },
              selected: false,
              type: 'AccountsPayable'
            };
          });

          this.nodes[courierNode.key].children = newShipments;

          if (courierNode.selected) {
            this.nodes[courierNode.key].children.map((item) => {
              item.selected = true;
              if (!this.selectedCheckbox.includes(item.data)) {
                this.selectedCheckbox.push(item.data);
              }
            });
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.loading = false;
        }
      }
    },

    actionsDropdownNfe(index, node) {
      this.nfeSelectedId = node.data.id;
      if (index === 0) {
        this.isOpenHistoryNfe = true;
      }
    },

    handleRedirectToReceiptsManagementByBoarding(boarding) {
      this.setSelectedCheckbox([boarding]);
      window.open('#/shipments/receipts', '_blank');
    },

    handleRedirectToReceiptsManagementByNfe(nfe) {
      this.setSelectedCheckbox([nfe]);
      window.open('#/shipments/receipts', '_blank');
    },

    transformDateToISOString(date) {
      this.$refs.menu.save(date);
      const partOfDate = date.split('-');
      const newDate = new Date(partOfDate[0], partOfDate[1] - 1, partOfDate[2]);
      return newDate.toISOString();
    },
    save1(date) {
      const newDate = this.transformDateToISOString(date);
      this.setFiltersDirectDelivererCreatedAtStart(newDate);

      this.filterSearch();
    },
    save2(date) {
      const newDate = this.transformDateToISOString(date);
      this.setFiltersDirectDelivererCreatedAtEnd(newDate);

      this.filterSearch();
    },
    saveCteNumber() {
      this.setFiltersDirectDelivererCteNumber(this.CTENumber);

      this.filterSearch();
    },
    saveDeliverer() {
      this.setFiltersDirectDelivererDirectDelivererId(this.directDelivererId);
      this.setFiltersManegementDirectDelivererId(this.directDelivererId);
      this.filterSearch();
    },
    transformDate(date) {
      return maskData(date);
    },
    transformPrice(price) {
      return maskPrice(price);
    },
    filterSearch() {
      this.fetchAllDirectDeliverers();
    },
    resetFilters() {
      this.setFiltersDirectDelivererCreatedAtStart(null);
      this.setFiltersDirectDelivererCreatedAtEnd(null);
      this.setFiltersDirectDelivererCteNumber(null);
      this.setFiltersDirectDelivererDirectDelivererId(null);
      this.setFiltersManegementDirectDelivererId(null);
    }
  }
};
</script>
<style lang="scss" scoped></style>
